<template>
  <v-container fluid class="youtube-videok">
    <div :class="{ 'page-content': !isMobile }">
      <div class="flex-center-between mb-2">
        <v-btn
          icon
          large
          color="primary"
          class="back-btn"
          @click="$goBackTo({ name: 'Fooldal' })"
        >
          <i class="fas fa-chevron-left"></i>
        </v-btn>
        <k-hamburger-icon class="back-btn" v-if="isMobile"></k-hamburger-icon>
      </div>
      <h2>{{ nyelvesites['videok_text'] }}</h2>
      <v-row class="my-2">
        <v-col cols="12" lg="3" md="6" v-for="(video, i) in videok" :key="i">
          <v-card class="video-container">
            <iframe :src="'https://www.youtube.com/embed/' + video.Id"></iframe>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { NotificationFunctions } from '../functions/NotificationFunctions';
import { hirService } from '../services/HirService';

export default {
  name: 'YoutubeVideok',
  data() {
    return {
      videokLoading: false,
      videok: [],
    };
  },
  mounted() {},
  created() {
    this.GetYoutubeVideok();
  },
  methods: {
    async GetYoutubeVideok() {
      this.videokLoading = true;
      try {
        this.videok = await hirService.GetYoutubeVideok();
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.videokLoading = false;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  components: {},
};
</script>
